import Const from 'constants';

let PlayerSettingPopup = {
    setSettingPopupState(data) {
        return {
            type: Const.PLAYER_SETTING_POPUP_SET_STATE,
            data,
        };
    },
};

export default PlayerSettingPopup;
